module.exports = __webpack_public_path__ + "static/media/019_A_infopanel.8e87d674.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/019_A_infopanel.png
// module id = 583
// module chunks = 0